<template>
    <footer class="has-text-centered has-background-dark" style="height: 50px;line-height:50px">
        <p>&copy 2019 STORMPORT</p>
        <!--
      <p v-if="$store.state.environment != 'production' && $store.state.Auth.user.id" class="has-text-grey">
        {{ $store.getters['Auth/fullName'] }} : {{ $store.state.Auth.user.email }}
      </p>
      <p>{{ appName }} &copy; {{ copyYear }}</p>
      <p v-if="$store.state.environment != 'production-X'" style="margin-top: 1rem;">
          <button class="button is-dark" @click="onReload">
              <span class="icon is-medium">
                  <i class="fa fa-refresh"></i>
              </span>
          </button>
      </p>
      -->
    </footer>
</template>
<script>
export default {
    name: 'app-footer',
    data() {
    	return {
    		appName: 'STORMPORT',
    		copyYear: ''
    	}
    },
    mounted() {
    	this.$data.copyYear = (new Date()).getFullYear();
    },
    methods: {

        onReload() {

            window.location.reload(true);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/partials/Footer.vue